export default {
  placeOrderTime: {
    zh_cn: '下单时间',
    zhhant: '下單時間',
    en: 'Order Time',
    he: 'זמן הזמנה',
    de: 'Bestellzeit',
    es: 'Hora de pedido',
    ru: 'Время заказа',
    vi: 'Thời gian đặt hàng',
  },
  sessionDetail: {
    zh_cn: '订单详情',
    zhhant: '訂單詳情',
    en: 'Session Detail',
    he: 'פרטי הזמנה',
    de: 'Sitzung Details',
    es: 'Detalles de la sesión',
    ru: 'Подробности сессии',
    vi: 'Chi tiết phiên',
  },
  orderID: {
    zh_cn: '订单编号',
    zhhant: '訂單編號',
    en: 'Session ID',
    he: 'מזהה הזמנה',
    de: 'Bestell-ID',
    es: 'ID de pedido',
    ru: 'ID заказа',
    vi: 'ID đơn hàng',
  },
  chargingOrder: {
    zh_cn: '充电订单',
    zhhant: '充電訂單',
    en: 'Charging Order',
    he: 'הזמנה לטעינה',
    de: 'Ladebestellung',
    es: 'Pedido de carga',
    ru: 'Заказ зарядки',
    vi: 'Đơn hàng sạc',
  },
  stopReasonCode: {
    zh_cn: '停止码',
    zhhant: '停止碼',
    en: 'Stop Code',
    he: 'קוד לעצור',
    de: 'Stop-Code',
    es: 'Código de detención',
    ru: 'Код остановки',
    vi: 'Mã dừng',
  },
  stopReason: {
    zh_cn: '停止原因',
    zhhant: '停止原因',
    en: 'Stop Reason',
    he: 'סיבה לעצור',
    de: 'Stopgrund',
    es: 'Motivo de detención',
    ru: 'Причина остановки',
    vi: 'Lý do dừng',
  },
  costDetails: {
    zh_cn: '计费明细',
    zhhant: '計費明細',
    en: 'Cost Details',
    he: 'פרטי עלות',
    de: 'Kostendetails',
    es: 'Detalles de costos',
    ru: 'Детали стоимости',
    vi: 'Chi tiết chi phí',
  },
  meterValueSampling: {
    zh_cn: '充电监控',
    zhhant: '充電監控',
    en: 'Meter Value Sampling',
    he: 'מדלקה ערך מדידה',
    de: 'Messung der Messwerte',
    es: 'Muestreo de valores del medidor',
    ru: 'Примерка значений счетчика',
    vi: 'Lấy mẫu giá trị đếm',
  },
  orderType: {
    zh_cn: '订单类型',
    zhhant: '訂單類型',
    en: 'Order Type',
    he: 'סוג הזמנה',
    de: 'Bestell-Typ',
    es: 'Tipo de pedido',
    ru: 'Тип заказа',
    vi: 'Loại đơn hàng',
  },
  location: {
    zh_cn: '商户站点',
    zhhant: '商戶站點',
    en: 'Location',
    he: 'מיקום',
    de: 'Standort',
    es: 'Ubicación',
    ru: 'Местоположение',
    vi: 'Địa điểm',
  },
  user: {
    zh_cn: '用户',
    zhhant: '用戶',
    en: 'Driver',
    he: 'משתמש',
    de: 'Fahrer',
    es: 'Usuario',
    ru: 'Пользователь',
    vi: 'Người dùng',
  },
  authType: {
    zh_cn: '授权类型',
    zhhant: '授權類型',
    en: 'Authorization',
    he: 'סוג הרשאה',
    de: 'Autorisierung',
    es: 'Tipo de autorización',
    ru: 'Тип авторизации',
    vi: 'Loại xác thực',
  },
  evse: {
    zh_cn: '设备',
    zhhant: '設備',
    en: 'EVSE',
    he: 'EVSE',
    de: 'EVSE',
    es: 'EVSE',
    ru: 'EVSE',
    vi: 'EVSE',
  },
  placeOrder: {
    zh_cn: '下单',
    zhhant: '下單',
    en: 'Place Order',
    he: 'הזמנה',
    de: 'Bestellen',
    es: 'Realizar pedido',
    ru: 'Подтвердить заказ',
    vi: 'Đặt hàng',
  },
  startCharging: {
    zh_cn: '开始充电',
    zhhant: '開始充電',
    en: 'Start Charging',
    he: 'התחל טעינה',
    de: 'Laden starten',
    es: 'Iniciar carga',
    ru: 'Начать зарядку',
    vi: 'Bắt đầu sạc',
  },
  stopCharging: {
    zh_cn: '结束充电',
    zhhant: '結束充電',
    en: 'Stop Charging',
    he: 'סיים טעינה',
    de: 'Laden beenden',
    es: 'Detener carga',
    ru: 'Остановить зарядку',
    vi: 'Dừng sạc',
  },
  settlement: {
    zh_cn: '结算',
    zhhant: '結算',
    en: 'Settlement',
    he: 'סכום',
    de: 'Zahlung',
    es: 'Liquidación',
    ru: 'Счет',
    vi: 'Thanh toán',
  },
  walletSettlement: {
    zh_cn: '钱包结算',
    zhhant: '錢包結算',
    en: 'Wallet Settlement',
    he: 'פתיחת חשבון',
    de: 'Wallet-Abrechnung',
    es: 'Liquidación de la billetera',
    ru: 'Расчет с кошельком',
    vi: 'Thanh toán ví'
  },
  walletSettlementTip: {
    zh_cn: '钱包结算常用于微信/支付宝等预付费订单异常退款时，后台工作人员使用钱包结算, 来进行收款。注意: 确定钱包中余额足够支付订单金额。',
    zhhant: '钱包结算常用于微信/支付宝等预付费订单异常退款时，后台工作人员使用钱包结算, 来进行收款。注意: 确定钱包中余额足够支付订单金额。',
    en: 'Wallet settlement is often used for abnormal refunds of prepaid orders such as WeChat/Alipay. The back-end staff uses wallet settlement to collect payments. Note: Make sure the balance in the wallet is sufficient to cover the order amount.',
    he: 'פתיחת חשבון באתר היא שימושית לעיתים בהחזרות חריגות של הזמנות בתשלום מראש כמו WeChat/Alipay. צוות האתר משתמש בפתיחת חשבון באתר, כדי לקבל תשלומים. שימו לב: ודא שהיתרה בחשבון מספיקה לכסות את סכום ההזמנה.',
    de: 'Die Wallet-Abrechnung wird häufig für ungewöhnliche Rückerstattungen von Vorauszahlungsaufträgen wie WeChat/Alipay verwendet. Das Back-End-Personal nutzt die Wallet-Abrechnung, um Zahlungen zu erhalten. Hinweis: Stellen Sie sicher, dass der Guthaben in der Wallet ausreichend ist, um den Auftragsbetrag zu decken.',
    es: 'La liquidación de la billetera se utiliza a menョn de retornos anormales de pedidos con anticipo como WeChat/Alipay. El personal del backend utiliza la liquidación de la billetera para recibir pagos. Nota: asegúrese de que el saldo de la billetera sea suficiente para cubrir el monto del pedido.',
    ru: 'Расчет с кошельком часто используется для нестандартного возврата средств за предварительно оплаченные заказы, такие как WeChat/Alipay. Персонал бэк-энда используется для приема платежей. Примечание: убедитесь, что баланс в кошельке достаточный для покрытия стоимости заказа.',
    vi: 'Thanh toán ví thường được sử dụng cho hoàn tiền bất thường của đơn hàng trả trước như WeChat/Alipay. Nhân viên phụ trách sẽ sử dụng thanh toán ví để nhận thanh toán. Lưu ý: Hãy chắc chắn số dư trong ví là đủ để chi trả số tiền đơn hàng.',
  },
  paymentInfo: {
    zh_cn: '支付信息',
    zhhant: '支付資訊',
    en: 'Payment Information',
    he: 'מידע על תשלום',
    de: 'Zahlungsinformationen',
    es: 'Información de pago',
    ru: 'Информация по оплате',
    vi: 'Thông tin thanh toán',
  },
  paymentEndpoint: {
    zh_cn: '下单终端',
    zhhant: '下單終端',
    en: 'Payment Terminal',
    he: 'מסוף תשלום',
    de: 'Zahlungsterminal',
    es: 'Terminal de pago',
    ru: 'Платежный терминал',
    vi: 'Điểm thanh toán',
  },
  paymentMethod: {
    zh_cn: '支付方式',
    zhhant: '支付方式',
    en: 'Payment Method',
    he: 'אמצעי תשלום',
    de: 'Zahlungsmethode',
    es: 'Método de pago',
    ru: 'Способ оплаты',
    vi: 'Phương thức thanh toán',
  },
  paymentMode: {
    zh_cn: '支付类型',
    zhhant: '支付類型',
    en: 'Payment Type',
    he: 'סוג תשלום',
    de: 'Zahlungstyp',
    es: 'Tipo de pago',
    ru: 'Тип оплаты',
    vi: 'Loại thanh toán',
  },
  paymentAmount: {
    zh_cn: '支付本金金额',
    zhhant: '支付本金金額',
    en: 'Payment Principal Amount',
    he: 'סכום הכיסוי הראשי',
    de: 'Zahlung Hauptbetrag',
    es: 'Cantidad principal de pago',
    ru: 'Основная сумма платежа',
    vi: 'Số tiền thanh toán chính',
  },
  useGiftAmount: {
    zh_cn: '支付赠送金额',
    zhhant: '支付贈送金額',
    en: 'Payment Gift Amount',
    he: 'סכום מתנה',
    de: 'Zahlungsgeschenkbetrag',
    es: 'Cantidad de regalo del pago',
    ru: 'Сумма подарка по оплате',
    vi: 'Số tiền quà tặng thanh toán',
  },
  refundAmount: {
    zh_cn: '退款金额',
    zhhant: '退款金額',
    en: 'Refund Amount',
    he: 'סכום החזר',
    de: 'Rückerstattungsbetrag',
    es: 'Cantidad de reembolso',
    ru: 'Сумма возврата',
    vi: 'Số tiền hoàn trả',
  },
  paidAmount: {
    zh_cn: '最终支付金额',
    zhhant: '最终支付金額',
    en: 'Paid Amount',
    he: 'סכום ששולם',
    de: 'Bezahlter Betrag',
    es: 'Cantidad pagada',
    ru: 'Оплаченная сумма',
    vi: 'Số tiền thanh toán',
  },
  paymentState: {
    zh_cn: '支付状态',
    zhhant: '支付狀態',
    en: 'Payment State',
    he: 'מצב תשלום',
    de: 'Zahlungszustand',
    es: 'Estado de pago',
    ru: 'Состояние оплаты',
    vi: 'Trạng thái thanh toán',
  },
  settlementInfo: {
    zh_cn: '结算信息',
    zhhant: '結算資訊',
    en: 'Settlement Information',
    he: 'מידע על סכום',
    de: 'Zahlungsinformationen',
    es: 'Información de liquidación',
    ru: 'Информация о счете',
    vi: 'Thông tin thanh toán',
  },
  occupy: {
    zh_cn: '占桩',
    zhhant: '佔桩',
    en: 'Occupy',
    he: 'מכיל',
    de: 'Belegung',
    es: 'Ocupación',
    ru: 'Занятое',
    vi: 'Chiếm giữ',
  },
  lastOccupyTime: {
    zh_cn: '最后占桩时间',
    zhhant: '最後佔桩時間',
    en: 'Last Occupy Time',
    he: 'זמן אחרון מכיל',
    de: 'Letzte Belegung',
    es: 'Última ocupación',
    ru: 'Последнее занятие',
    vi: 'Thời gian chiếm giữ cuối cùng',
  },
  occupyFinish: {
    zh_cn: '占桩结束',
    zhhant: '佔桩結束',
    en: 'Occupy Finish',
    he: 'מכיל בוטל',
    de: 'Belegung beendet',
    es: 'Ocupación finalizada',
    ru: 'Занятое закончено',
    vi: 'Hoàn tất chiếm giữ',
  },
  occupying: {
    zh_cn: '占桩中',
    zhhant: '佔桩中',
    en: 'Occupying',
    he: 'מכיל',
    de: 'Belegung',
    es: 'Ocupación',
    ru: 'Занятое',
    vi: 'Đang chiếm giữ',
  },
  occupyRangeTime: {
    zh_cn: '占桩起止时间',
    zhhant: '占桩起訖時間',
    en: 'Occupy Range Time',
    he: 'טיימר תחילה וסיום',
    de: 'Ladebeginn und -ende',
    es: 'Hora de inicio y fin',
    ru: 'Время начала и окончания использования',
    vi: 'Thời gian chiếm giữ và kết thúc',
  },
  occupyPricing: {
    zh_cn: '占桩定价',
    zhhant: '占桩定价',
    en: 'Occupy Pricing',
    he: 'מחיר תחילה',
    de: 'Ladepreis',
    es: 'Precio de carga',
    ru: 'Цена за использование',
    vi: 'Giá sử dụng',
  },
  chargingRangeTime: {
    zh_cn: '充电起止时间',
    zhhant: '充電起訖時間',
    en: 'Start and End Time',
    he: 'זמן התחלה וסיום',
    de: 'Ladebeginn und -ende',
    es: 'Hora de inicio y fin',
    ru: 'Время начала и окончания зарядки',
    vi: 'Thời gian bắt đầu và kết thúc',
  },
  orderElec: {
    zh_cn: '充电电量',
    zhhant: '充電電量',
    en: 'Energy Used',
    he: 'אנרגיה שנעשה בה שימוש',
    de: 'Verbrauchte Energie',
    es: 'Energía usada',
    ru: 'Потребленная энергия',
    vi: 'Năng lượng sử dụng',
  },
  energyUsedFee: {
    zh_cn: '充电电费',
    zhhant: '充電電費',
    en: 'Energy Fee',
    he: 'עמלה אנרגיה',
    de: 'Energiekosten',
    es: 'Cuota de energía',
    ru: 'Стоимость энергии',
    vi: 'Chi phí năng lượng',
  },
  energyUsedFeeDesc: {
    zh_cn: '所有折扣前的电站标价计算出的电费费用=电度数*电站电费标价',
    zhhant: '所有折扣前的電站標價計算出的電費費用=電度數*電站電費標價',
    en: 'The electricity fee calculated before all discounts is the station price = energy * station electricity price',
    he: 'עמלה אנרגיה שנמחקה לפני כל הנחה היא הערך של אנרגיה = אנרגיה * עמלה אנרגיה של אנרגיה',
    de: 'Die Energierechnung vor allen Rabatten ist die Stationspreis = Energie * Stationsenergiekosten',
    es: 'La factura de energía antes de todos los descuentos es el precio de la estación = energía * precio de energía de la estación',
    ru: 'Стоимость энергии до всех скидок рассчитывается как стоимость станции = энергия * стоимость энергии станции',
    vi: 'Chi phí năng lượng trước tất cả các giảm giá là giá của quán = năng lượng * chi phí năng lượng của quán',
  },
  serviceFee: {
    zh_cn: '服务费',
    zhhant: '服務費',
    en: 'Service Fee',
    he: 'עמלה שירות',
    de: 'Servicegebühr',
    es: 'Cuota de servicio',
    ru: 'Стоимость услуги',
    vi: 'Chi phí dịch vụ',
  },
  serviceFeeDesc: {
    zh_cn: '所有折扣前的电站标价计算出的服务费费用=电度数*电站服务费标价',
    zhhant: '所有折扣前的電站標價計算出的服務費費用=電度數*電站服務費標價',
    en: 'The service fee calculated before all discounts is the station price = energy * station service fee price',
    he: 'עמלה שירות שנמחקה לפני כל הנחה היא הערך של אנרגיה = אנרגיה * עמלה שירות של אנרגיה',
    de: 'Die Servicegebühr vor allen Rabatten ist die Stationspreis = Energie * Stationsdienstleistungsgebühren',
    es: 'La factura de servicio antes de todos los descuentos es el precio de la estación = energía * precio de servicio de la estación',
    ru: 'Стоимость услуги до всех скидок рассчитывается как стоимость станции = энергия * стоимость услуги станции',
    vi: 'Chi phí dịch vụ trước tất cả các giảm giá là giá của quán = năng lượng * chi phí dịch vụ của quán',
  },
  discounts: {
    zh_cn: '优惠',
    zhhant: '優惠',
    en: 'Discounts',
    he: 'הנחה',
    de: 'Rabatte',
    es: 'Descuentos',
    ru: 'Скидки',
    vi: 'Giảm giá',
  },
  discountsDesc: {
    zh_cn: '当前订单享受的运营商发起电站折扣活动抵扣金额',
    zhhant: '當前訂單享有運營商發起電站折扣活動抵扣金額',
    en: 'The amount deducted from the current order after the operator initiates the station discount activity',
    he: 'הכמות שנשלחה לתקן הנוכחי לאחר שהאובר מבצע את הפעילות של הנחה של אנרגיה',
    de: 'Der Betrag, der von dem aktuellen Auftrag abgezogen wird, nachdem der Anbieter die Stationenrabattaktivität initiiert hat',
    es: 'El importe que se deducirá del pedido actual después de que el operador inicie la actividad de descuento de la estación',
    ru: 'Сумма снята со текущего заказа после того, как оператор инициировал активность скидок станций',
    vi: 'Số tiền được trừ khỏi đơn hàng hiện tại sau khi nhà cung cấp kích hoạt hoạt động giảm giá của quán',
  },
  settlementAmount: {
    zh_cn: '结算金额',
    zhhant: '結算金額',
    en: 'Settlement Amount',
    he: 'סכום לתקן',
    de: 'Zahlbetrag',
    es: 'Importe de liquidación',
    ru: 'Сумма счета',
    vi: 'Số tiền thanh toán',
  },
  settlementAmountDesc: {
    zh_cn: '订单结算金额 = 电费 + 服务费 - 优惠',
    zhhant: '訂單結算金額 = 电費 + 服務費 - 優惠',
    en: 'The settlement amount of the order = electricity fee + service fee - discount',
    he: 'סכום לתקן שנשלחה לתקן הנוכחי הוא הערך של אנרגיה + עמלה שירות + הנחה',
    de: 'Der Zahlbetrag des aktuellen Auftrags ist der Energiepreis + Servicegebühr + Rabatt',
    es: 'El importe de liquidación del pedido es la energía + factura de servicio + descuento',
    ru: 'Сумма счета заказа рассчитывается как электрическая плата + услуга + скидка',
    vi: 'Số tiền thanh toán của đơn hàng được tính là giá điện + phí dịch vụ + giảm giá',
  },
  orderAmount: {
    zh_cn: '充电金额',
    zhhant: '充電金額',
    en: 'Cost',
    he: 'עלות',
    de: 'Kosten',
    es: 'Costo',
    ru: 'Стоимость',
    vi: 'Chi phí',
  },
  occupyAmount: {
    zh_cn: '占桩金额',
    zhhant: '占樁金額',
    en: 'Occupy Amount',
    he: 'עלות לתקן',
    de: 'Zahlbetrag',
    es: 'Importe de liquidación',
    ru: 'Сумма счета',
    vi: 'Số tiền thanh toán',
  },
  chargeStateProgress: {
    zh_cn: '正在进行充电',
    zhhant: '正在進行充電',
    en: 'Charging in Progress',
    he: 'טעינה בתהליך',
    de: 'Laden in Bearbeitung',
    es: 'Cargando en progreso',
    ru: 'Зарядка в процессе',
    vi: 'Đang sạc',
  },
  chargeStateAbnormal: {
    zh_cn: '充电异常',
    zhhant: '充電異常',
    en: 'Abnormal',
    he: 'אנומליה',
    de: 'Abnormal',
    es: 'Anormal',
    ru: 'Аномалия',
    vi: 'Bất thường',
  },
  chargeStateInit: {
    zh_cn: '初始下单',
    zhhant: '初始下單',
    en: 'Place Order',
    he: 'הזמנה',
    de: 'Bestellung',
    es: 'Pedido',
    ru: 'Заказ',
    vi: 'Đặt hàng',
  },
  chargeStatePending: {
    zh_cn: '启动指令已下发，订单等待处理',
    zhhant: '啟動指令已發出，訂單等待處理',
    en: 'Pending',
    he: 'ממתין',
    de: 'Ausstehend',
    es: 'Pendiente',
    ru: 'Ожидание',
    vi: 'Đang chờ xử lý',
  },
  chargeStateRemoteStartReject: {
    zh_cn: '设备拒绝启动充电',
    zhhant: '設備拒絕啟動充電',
    en: 'Remote Start Reject',
    he: 'הפסקת הפעלה מרחוק',
    de: 'Fernstart abgelehnt',
    es: 'Rechazo de inicio remoto',
    ru: 'Удаленный запуск отклонен',
    vi: 'Khởi động từ xa bị từ chối',
  },
  chargeStateRemoteStartTimeout: {
    zh_cn: '启动充电超时',
    zhhant: '啟動充電超時',
    en: 'Remote Start Timeout',
    he: 'פסק זמן הפעלה מרחוק',
    de: 'Fernstart-Zeitüberschreitung',
    es: 'Tiempo de espera para inicio remoto',
    ru: 'Таймаут удаленного запуска',
    vi: 'Hết thời gian khởi động từ xa',
  },
  chargeStateRemoteStartFail: {
    zh_cn: '启动充电失败，后台导致的',
    zhhant: '啟動充電失敗，後臺導致的',
    en: 'Remote Start Fail',
    he: 'כשלון הפעלה מרחוק',
    de: 'Fernstart-Fehler',
    es: 'Fallo en el inicio remoto',
    ru: 'Неудача при удаленном запуске',
    vi: 'Khởi động từ xa thất bại',
  },
  chargeStateReserver: {
    zh_cn: '预约成功',
    zhhant: '預約成功',
    en: 'Reserved',
    he: 'הוזמן',
    de: 'Reserviert',
    es: 'Reservado',
    ru: 'Зарезервировано',
    vi: 'Đã đặt',
  },
  chargeStateReserverExpires: {
    zh_cn: '预约过期',
    zhhant: '預約過期',
    en: 'Expired',
    he: 'הזמן, פג',
    de: 'Ausgelaufen',
    es: 'Expirado',
    ru: 'Истекло',
    vi: 'Hết hạn',
  },
  chargeStateReserverCancel: {
    zh_cn: '预约取消',
    zhhant: '預約取消',
    en: 'Canceled',
    he: 'הוזמן, בוטל',
    de: 'Abgebrochen',
    es: 'Cancelado',
    ru: 'Отменено',
    vi: 'Đã hủy',
  },
  chargeStateRemoteStarted: {
    zh_cn: '启动充电成功，等待连接',
    zhhant: '啟動充電成功，等待連接',
    en: 'Connecting',
    he: 'מחובר',
    de: 'Verbindung wird hergestellt',
    es: 'Conectando',
    ru: 'Подключение',
    vi: 'Đang kết nối',
  },
  chargeStateConnectTimeout: {
    zh_cn: '连接超时',
    zhhant: '連接超時',
    en: 'Connect Timeout',
    he: 'פסק זמן חיבור',
    de: 'Verbindungs-Zeitüberschreitung',
    es: 'Tiempo de espera de conexión',
    ru: 'Таймаут подключения',
    vi: 'Hết thời gian kết nối',
  },
  chargeStateConnectorUnavailableSuspend: {
    zh_cn: '枪头不可用导致订单挂起',
    zhhant: '槍頭不可用導致訂單掛起',
    en: 'Connector Unavailable Suspend',
    he: 'חיבור לא זמין, השעיה',
    de: 'Connector nicht verfügbar, Aussetzung',
    es: 'Conector no disponible, suspendido',
    ru: 'Разъем недоступен, приостановка',
    vi: 'Cổng không khả dụng, tạm dừng',
  },
  chargeStateCharging: {
    zh_cn: '充电中',
    zhhant: '充電中',
    en: 'Charging',
    he: 'טעינה',
    de: 'Laden',
    es: 'Cargando',
    ru: 'Зарядка',
    vi: 'Đang sạc',
  },
  chargeStateConnectorDiffSessionSuspend: {
    zh_cn: '枪头的订单会话不一致导致挂起',
    zhhant: '槍頭的訂單會話不一致導致掛起',
    en: 'Connector Diff Session Suspend',
    he: 'שיעור חיבור שונה, השעיה',
    de: 'Connector unterschiedliche Sitzung, Aussetzung',
    es: 'Conector con sesión diferente, suspendido',
    ru: 'Разъем с разной сессией, приостановка',
    vi: 'Cổng khác phiên, tạm dừng',
  },
  chargeStateConnectorAvailableSuspend: {
    zh_cn: '枪头空闲可用导致订单挂起',
    zhhant: '槍頭空閒可用導致訂單掛起',
    en: 'Connector Available Suspend',
    he: 'חיבור זמין, השעיה',
    de: 'Connector verfügbar, Aussetzung',
    es: 'Conector disponible, suspendido',
    ru: 'Разъем свободен, приостановка',
    vi: 'Cổng sẵn có, tạm dừng',
  },
  chargeStateConnectorFaultSuspend: {
    zh_cn: '枪头故障导致订单挂起',
    zhhant: '槍頭故障導致訂單掛起',
    en: 'Connector Fault Suspend',
    he: 'פגם בחיבור, השעיה',
    de: 'Connector-Fehler, Aussetzung',
    es: 'Fallo del conector, suspendido',
    ru: 'Неисправность разъема, приостановка',
    vi: 'Lỗi cổng, tạm dừng',
  },
  chargeStateConnectorOfflineSuspend: {
    zh_cn: '枪头离线导致订单挂起',
    zhhant: '槍頭離線導致訂單掛起',
    en: 'Connector Offline Suspend',
    he: 'חיבור לא מחובר, השעיה',
    de: 'Connector offline, Aussetzung',
    es: 'Conector fuera de línea, suspendido',
    ru: 'Разъем офлайн, приостановка',
    vi: 'Cổng ngoại tuyến, tạm dừng',
  },
  chargeStateDead: {
    zh_cn: '长时间不活跃，订单挂起',
    zhhant: '長時間不活躍，訂單掛起',
    en: 'Dead',
    he: 'לא פעיל',
    de: 'Inaktiv',
    es: 'Inactivo',
    ru: 'Неактивен',
    vi: 'Ngừng hoạt động',
  },
  chargeStateRemoteStopped: {
    zh_cn: '请求停止充电',
    zhhant: '請求停止充電',
    en: 'Remote Stopped',
    he: 'הפסקה מרחוק',
    de: 'Fernstop',
    es: 'Parada remota',
    ru: 'Удаленное остановление',
    vi: 'Dừng từ xa',
  },
  chargeStateRemoteStopTimeout: {
    zh_cn: '结束充电超时',
    zhhant: '結束充電超時',
    en: 'Remote Stop Timeout',
    he: 'פסק זמן הפסקה מרחוק',
    de: 'Fernstop-Zeitüberschreitung',
    es: 'Tiempo de espera para parada remota',
    ru: 'Таймаут удаленной остановки',
    vi: 'Hết thời gian dừng từ xa',
  },
  chargeStateStopped: {
    zh_cn: '等待计费结果',
    zhhant: '等待計費結果',
    en: 'Stopped',
    he: 'הפסקה',
    de: 'Gestoppt',
    es: 'Detenido',
    ru: 'Остановлено',
    vi: 'Đã dừng',
  },
  chargeStateCostConflict: {
    zh_cn: '费用冲突',
    zhhant: '費用衝突',
    en: 'Cost Conflict',
    he: 'סכסוך עלות',
    de: 'Kostenkonflikt',
    es: 'Conflicto de costos',
    ru: 'Конфликт стоимости',
    vi: 'Xung đột chi phí',
  },
  chargeStateFinish: {
    zh_cn: '充电完成',
    zhhant: '充電完成',
    en: 'Completed',
    he: 'הושלם',
    de: 'Abgeschlossen',
    es: 'Completado',
    ru: 'Завершено',
    vi: 'Hoàn thành',
  },
  chargingState: {
    zh_cn: '充电状态',
    zhhant: '充電狀態',
    en: 'Charging State',
    he: 'מצב טעינה',
    de: 'Ladezustand',
    es: 'Estado de carga',
    ru: 'Состояние зарядки',
    vi: 'Tình trạng sạc',
  },
  reserverTag: {
    zh_cn: '预',
    zhhant: '預',
    en: 'R',
    he: 'R',
    de: 'R',
    es: 'R',
    ru: 'R',
    vi: 'R',
  },
  reserverAt: {
    zh_cn: '预约时间',
    zhhant: '約定時間',
    en: 'Reserve At',
    he: 'זמן הזמנה',
    de: 'Zeitfenster',
    es: 'Tiempo de reserva',
    ru: 'Время резервации',
    vi: 'Thời gian đặt trước',
  },
  reserverDesc: {
    zh_cn: '预约充电, 充电设备在预约时间内其他人不可充电。',
    zhhant: '預約充電，充電設備在預約時間內其他人不可充電。',
    en: 'Reserve charging, the charging device can not be charged by others in the reservation time.',
    he: 'הזמנה טעינה, מכונה שתקלה לא יכולה להיות בזמן הזמנת.',
    de: 'Reservierung der Ladezeit, das Ladegerät kann nicht von anderen im Zeitfenster reserviert werden.',
    es: 'Reserva de carga, el dispositivo de carga no puede ser cargado por otros en el tiempo reservado.',
    ru: 'Зарезервировать заряд, устройство зарядки не может быть заряжен другими в течение времени резервации.',
    vi: 'Đặt trước, thiết bị sạc không thể được đặt trước trong thời gian đặt trước.',
  },
  waitingSettlement: {
    zh_cn: '等待结算',
    zhhant: '等待結算',
    en: 'Waiting Settlement',
    he: 'ממתין לסכום',
    de: 'Warten auf Abrechnung',
    es: 'Esperando liquidación',
    ru: 'Ожидание вычета',
    vi: 'Chờ kết thúc',
  },
  settleStateInit: {
    //  准备结算
    zh_cn: '准备结算',
    zhhant: '準備結算',
    en: 'Init',
    he: 'תחילה',
    de: 'Initialisierung',
    es: 'Inicializar',
    ru: 'Начало',
    vi: 'Chuẩn bị',
  },
  settleStateProcess: {
    //  结算中
    zh_cn: '结算中',
    zhhant: '結算中',
    en: 'Process',
    he: 'בביצוע',
    de: 'Verarbeitung',
    es: 'Procesar',
    ru: 'Выполнение',
    vi: 'Đang thực hiện',
  },
  settleStateAbnormal: {
    //  结算未知异常
    zh_cn: '结算未知异常',
    zhhant: '結算未知異常',
    en: 'Abnormal',
    he: 'לא ידוע',
    de: 'Unklar',
    es: 'Anormal',
    ru: 'Неизвестный',
    vi: 'Không rõ',
  },
  settleStateAbnormalExcess: {
    //  结算异常状态，充超额了
    zh_cn: '支付异常，无法结算',
    zhhant: '支付異常，無法結算',
    en: 'Payment abnormal, unable to settle',
    he: 'בעיה בתשלום, לא ניתן לבצע ביצוע',
    de: 'Zahlung nicht normal, kann nicht abrechnen',
    es: 'Anormalidad de pago, no se puede liquidar',
    ru: 'Нестандартное выплата, невозможно выполнить вычет',
    vi: 'Thanh toán bất thường, không thể hoàn tất',
  },
  settleStateAbnormalBizNonFinishState: {
    //  业务不是处于完成状态，无法结算
    zh_cn: '业务不是处于完成状态，无法结算',
    zhhant: '業務不是處於完成狀態，無法結算',
    en: 'Business is not in the completed state, unable to settle',
    he: 'העסקת לא בסטטוס הושלם, לא ניתן לבצע ביצוע',
    es: 'El negocio no está en el estado completado, no se puede liquidar',
    ru: 'Бизнес не находится в состоянии завершения, невозможно выполнить вычет',
    vi: 'Dịch vụ không ở trạng thái hoàn thành, không thể thực hiện',
  },
  settleStateAbnormalWalletLackMoney: {
    //  钱包余额不足
    zh_cn: '钱包余额不足',
    zhhant: '錢包餘額不足',
    en: 'Wallet balance is insufficient',
    he: 'אזור כספי לא מספיק',
    de: 'Guthaben nicht ausreichend',
    es: 'Saldo de billetera insuficiente',
    ru: 'Баланс кошелька недостаточен',
    vi: 'Số dư ví không đủ',
  },
  settleStateSuccess: {
    //  业务正常完成
    zh_cn: '结算完成',
    zhhant: '結算完成',
    en: 'Settlement Completed',
    he: 'הבצעת ביצוע',
    de: 'Zahlung abgeschlossen',
    es: 'Liquidación completada',
    ru: 'Выполнено вычет',
    vi: 'Thực hiện thành công',
  },
  payState: {
    zh_cn: '支付状态',
    zhhant: '支付狀態',
    en: 'Payment State',
    he: 'סטטוס תשלום',
    de: 'Zahlungszustand',
    es: 'Estado de pago',
    ru: 'Состояние выплаты',
    vi: 'Trạng thái thanh toán',
  },
  payStateInit: {
    // 初始化状态(改成1,避免0值问题)
    zh_cn: '下单',
    zhhant: '下單',
    en: 'Init',
    he: 'תחילה',
    de: 'Initialisierung',
    es: 'Inicializar',
    ru: 'Начало',
    vi: 'Chuẩn bị',
  },
  payStatePayPending: {
    // 待支付
    zh_cn: '待支付',
    zhhant: '待支付',
    en: 'Unpaid',
    he: 'לשלם',
    de: 'Zahlung ausstehend',
    es: 'Pendiente de pago',
    ru: 'Не оплачено',
    vi: 'Chưa thanh toán',
  },
  payStatePayProcessing: {
    // 支付中
    zh_cn: '支付中',
    zhhant: '支付中',
    en: 'Be paying',
    he: 'מבצעת תשלום',
    de: 'Zahlung in Bearbeitung',
    es: 'Procesando pago',
    ru: 'Выполняется выплата',
    vi: 'Đang thực hiện thanh toán',
  },
  payStatePaySuccess: {
    // 支付成功
    en: 'Paid',
    zh_cn: '支付成功',
    zhhant: '支付成功',
    he: 'שלם',
    de: 'Bezahlt',
    es: 'Pagado',
    ru: 'Оплачено',
    vi: 'Đã thanh toán',
  },
  payStatePayFail: {
    // 支付失败
    zh_cn: '支付失败',
    zhhant: '支付失敗',
    en: 'Payment failed',
    he: 'שלום נכשל',
    de: 'Zahlung fehlgeschlagen',
    es: 'Pago fallido',
    ru: 'Не оплачено',
    vi: 'Thanh toán thất bại',
  },
  payStateRefundInit: {
    // 待退款
    zh_cn: '待退款',
    zhhant: '待退款',
    en: 'To be refunded',
    he: 'לשחזר',
    de: 'Zurückerstattung ausstehend',
    es: 'Pendiente de reembolso',
    ru: 'Не возвращено',
    vi: 'Chưa hoàn trả',
  },
  payStateRefunding: {
    // 退款中
    zh_cn: '退款中',
    zhhant: '退款中',
    en: 'Refunding',
    he: 'מבצעת שחזור',
    de: 'Rückerstattung in Bearbeitung',
    es: 'Reembolso en proceso',
    ru: 'Выполняется возврат',
    vi: 'Đang thực hiện hoàn trả',
  },
  payStateRebates: {
    // 部分退款
    zh_cn: '部分退款',
    zhhant: '部分退款',
    en: 'Partial refund',
    he: 'שחזור חלקי',
    de: 'Teilrückerstattung',
    es: 'Reembolso parcial',
    ru: 'Частично возвращено',
    vi: 'Hoàn trả phần',
  },
  payStateRefunded: {
    // 全额退款
    zh_cn: '退款',
    zhhant: '退款',
    en: 'Refunded',
    he: 'שחזר',
    de: 'Rückerstattet',
    es: 'Reembolsado',
    ru: 'Возвращено',
    vi: 'Hoàn trả đầy đủ',
  },
  payStateClose: {
    // 订单关闭, 订单异常，不产生订单金额
    zh_cn: '关单',
    zhhant: '關單',
    en: 'Closed',
    he: 'סגור',
    de: 'Geschlossen',
    es: 'Cerrado',
    ru: 'Закрыто',
    vi: 'Đóng',
  },
  time: {
    zh_cn: '时间',
    zhhant: '時間',
    en: 'Time',
    he: 'זמן',
    de: 'Zeit',
    es: 'Tiempo',
    ru: 'Время',
    vi: 'Thời gian',
  },
  settlementTime: {
    zh_cn: '结算时间',
    zhhant: '結算時間',
    en: 'Settlement time',
    he: 'זמן ביצוע',
    de: 'Zahlungsbetrag',
    es: 'Hora de liquidación',
    ru: 'Время вычета',
    vi: 'Thời gian hoàn tất',
  },
  tradeTime: {
    zh_cn: '交易时间',
    zhhant: '交易時間',
    en: 'Trade time',
    he: 'זמן ענף',
    de: 'Handelstime',
    es: 'Hora de operación',
    ru: 'Время операции',
    vi: 'Thời gian giao dịch',
  },
  tradeAmount: {
    zh_cn: '交易金额',
    zhhant: '交易金額',
    en: 'Trade amount',
    he: 'סכום ענף',
    de: 'Handelsbetrag',
    es: 'Importe de operación',
    ru: 'Сумма операции',
    vi: 'Số tiền giao dịch',
  },
  feeAmount: {
    zh_cn: '手续费',
    zhhant: '手續費',
    en: 'Fee amount',
    he: 'סכום עמלת',
    de: 'Gebühren',
    es: 'Importe de la tarifa',
    ru: 'Сумма комиссии',
    vi: 'Phí dịch vụ',
  },
  discountOrGiftAmount: {
    zh_cn: '优惠/赠送金额',
    zhhant: '優惠/贈送金額',
    en: 'Discount/gift amount',
    he: 'סכום скидka/המחיר',
    de: 'Rabatt- oder Gutscheinbetrag',
    es: 'Importe de descuento o regalo',
    ru: 'Сумма скидки или премия',
    vi: 'Số tiền ưu đãi/phụ cấp',
  },
  finallyAmount: {
    zh_cn: '最终金额',
    zhhant: '最終金額',
    en: 'Finally amount',
    he: 'סכום סופי',
    de: 'Endbetrag',
    es: 'Importe final',
    ru: 'Итоговая сумма',
    vi: 'Số tiền cuối cùng',
  },
  balanceAfterTrade: {
    zh_cn: '交易后余额',
    zhhant: '交易後餘額',
    en: 'Balance after trade',
    he: 'סכום אחרון',
    de: 'Guthaben nach dem Handel',
    es: 'Saldo después de operación',
    ru: 'Баланс после операции',
    vi: 'Số dư sau giao dịch',
  },
  push: {
    zh_cn: '推送订单',
    zhhant: '推送訂單',
    en: 'Push order',
    he: 'שלח הזמנה',
    de: 'Bestellung senden',
    es: 'Enviar pedido',
    ru: 'Переслать заказ',
    vi: 'Gửi đơn hàng',
  },
  pushDesc: {
    zh_cn: '常用于订单结算、消息通知、第三方推送触发等场景',
    zhhant: '常用于訂單結算、消息通知、第三方推送觸發等場景',
    en: 'Usually used in order settlement, message notification, third-party push trigger and other scenarios',
    he: 'נעשה בשימוש במספר תיאוריה כגון יידאו, הודעה, שליחת טיפול של צד 3rd וכו',
    de: 'Wird häufig für Bestellabschluss, Nachrichtenbenachrichtigungen und andere Szenarien verwendet',
    es: 'Usualmente se utiliza en el cierre de pedidos, notificaciones de mensajes y otros escenarios',
    ru: 'Используется часто в сценариях закрытия заказа, уведомления о сообщениях и других ситуациях',
    vi: 'Thường được sử dụng trong các mục đích đặt hàng, thông báo tin nhắn và các kịch bản khác',
  },
  reportingTip: {
    zh_cn:
      '账单以订单结算时间进行归档, 区别与充电概览的充电开始时间, 两者数据会有差异，对账以账单为准!!!',
    zhhant:
      '帳單以訂單結算時間進行歸檔, 區別與充電概覽的充電開始時間, 兩者數據會有差異，對帳以帳單為准!!!',
    en: 'Billing is archived based on the settlement time of the order, different from the charging overview start time, there will be a difference in the data, and the reconciliation is based on the billing!!!',
    he: 'החיוב מועבר על פי זמן ביצוע ההזמנה, שונה משעה התחלת התקשורת בסקירה, יש הבדל בנתונים, החיוב הוא המדוייק!!!',
    de: 'Die Abrechnung erfolgt auf Grundlage der Abschlusszeit des Bestellung, anders als die Startzeit der Ladeübersicht, es gibt Unterschiede in den Daten, und die Abstimmung erfolgt auf Grundlage der Rechnung!!!',
    es: 'La facturación se archiva en función de la hora de cierre del pedido, diferente a la hora de inicio de la carga en el resumen de la carga, habrá una diferencia en los datos, y la conciliación se basa en la facturación!!!',
    ru: 'Платежи по счетам ведутся на основе времени закрытия заказа, в отличие от времени начала зарядки в обзоре зарядки, в данных будут различия, и сверка по счетам!!!',
    vi: 'Hóa đơn được lưu trữ dựa trên thời điểm thanh toán, khác với thời điểm bắt đầu sạc trên Tổng quan sạc, dữ liệu sẽ có sự khác biệt, đối soát dựa trên hóa đơn!!!',
  },
  profitSharing: {
    zh_cn: '分润入账',
    zhhant: '分潤入賬',
    en: 'Profit sharing',
    he: 'שיתוף רווחים',
    de: 'Gewinnteile',
    es: 'Compartir beneficios',
    ru: 'Разделение выигрышей',
    vi: 'Chia lợi nhuận',
  },
  profitSharingRevocation: {
    zh_cn: '分润撤销',
    zhhant: '分潤撤銷',
    en: 'Profit sharing revocation',
    he: 'ביטול שיתוף הרווחים',
    de: 'Gewinnteile stornieren',
    es: 'Revocar el beneficio',
    ru: 'Отмена разбивки',
    vi: 'Hủy chia lợi nhuận',
  },
  withdraw: {
    zh_cn: '提现',
    zhhant: '提現',
    en: 'Withdraw',
    he: 'משיכה',
    de: 'Auszahlung',
    es: 'Retirar',
    ru: 'Вывести',
    vi: 'Rút tiền',
  },
  withdrawAudit: {
    zh_cn: '提现审核',
    zhhant: '提現審核',
    en: 'Withdraw audit',
    he: 'אישור משיכה',
    de: 'Auszahlungsprüfung',
    es: 'Auditoría de retiro',
    ru: 'Аудит вывода',
    vi: 'Kiểm duyệt rút tiền',
  },
  withdrawAmount: {
    zh_cn: '提现金额',
    zhhant: '提現金額',
    en: 'Withdraw amount',
    he: 'סכום משיכה',
    de: 'Auszahlungsbetrag',
    es: 'Importe de retiro',
    ru: 'Сумма вывода',
    vi: 'Số tiền rút',
  },
  minWithdrawAmount: {
    zh_cn: '最小提现金额',
    zhhant: '最小提現金額',
    en: 'Min withdraw amount',
    he: 'מינימום סכום משיכה',
    de: 'Mindestauszahlungsbetrag',
    es: 'Importe de retiro minimo',
    ru: 'Минимальная сумма вывода',
    vi: 'Số tiền rút tối thiểu',
  },
  withdrawApply: {
    zh_cn: '提现申请',
    zhhant: '提現申請',
    en: 'Withdraw apply',
    he: 'פתיחת בקשת משיכה',
    de: 'Auszahlungsantrag stellen',
    es: 'Solicitar retiro',
    ru: 'Запрос на вывод',
    vi: 'Đề nghị rút tiền',
  },
  auditState: {
    zh_cn: '审核状态',
    zhhant: '審核狀態',
    en: 'Audit state',
    he: 'מצב אישור',
    de: 'Prüfstatus',
    es: 'Estado de la auditoría',
    ru: 'Состояние аудита',
    vi: 'Trạng thái kiểm duyệt',
  },
  auditStateInit: {
    zh_cn: '待审核',
    zhhant: '待審核',
    en: 'Audit state init',
    he: 'מצב אישור התחלתי',
    de: 'Prüfstatus init',
    es: 'Estado de la auditoría inicial',
    ru: 'Начальное состояние аудита',
    vi: 'Trạng thái kiểm duyệt ban đầu',
  },
  auditStateRejected: {
    zh_cn: '审核拒绝',
    zhhant: '審核拒絕',
    en: 'Audit state rejected',
    he: 'מצב אישור נדחה',
    de: 'Prüfstatus zurückgestellt',
    es: 'Estado de la auditoría rechazada',
    ru: 'Аудит отклонен',
    vi: 'Trạng thái kiểm duyệt bị từ chối',
  },
  auditStateAccepted: {
    zh_cn: '审核通过',
    zhhant: '審核通過',
    en: 'Audit state accepted',
    he: 'מצב אישור מאושר',
    de: 'Prüfstatus akzeptiert',
    es: 'Estado de la auditoría aprobada',
    ru: 'Аудит принят',
    vi: 'Trạng thái kiểm duyệt được chấp nhận',
  },
  withdrawState: {
    zh_cn: '提现状态',
    zhhant: '提現狀態',
    en: 'Withdraw state',
    he: 'מצב משיכה',
    de: 'Auszahlungstatus',
    es: 'Estado de retiro',
    ru: 'Состояние вывода',
    vi: 'Trạng thái rút tiền',
  },
  withdrawApplyDesc: {
    zh_cn: '提现申请前，请认真核对银行卡号和开户行信息，确认无误后提交申请。',
    zhhant: '提现申請前，請認真核對銀行卡號和開戶行信息，確認無誤後提交申請。',
    en: 'Before applying for withdrawal, please carefully check the bank card number and opening bank information. Submit your application after confirming that there are no errors.',
    he: 'לפני פתיחת בקשת משיכה, אנא בדוק בקפידה מספר כרטיס הבנק ומידע על הבנק שפתח. שלח בקשתך לאחר אישור כי אין שגיאות.',
    de: 'Bevor Sie eine Auszahlungsantrag stellen, überprüfen Sie bitte die Bankkartennummer und Bankkontodaten. Senden Sie Ihre Anfrage nach Bestätigung, dass keine Fehler vorhanden sind.',
    es: 'Antes de solicitar el retiro, verifique cuidadosamente el número de la tarjeta bancaria y la información del banco. Enviar su aplicación después de confirmar que no hay errores.',
    ru: 'Перед запросом на вывод, пожалуйста, внимательно проверьте номер банковской карты и открывшее банк. Отправляйте запрос после подтверждения, что ошибок нет.',
    vi: 'Trước khi yêu cầu rút tiền, vui lòng kiểm tra kỹ số thẻ ngân hàng và thông tin ngân hàng. Gửi yêu cầu sau khi xác nhận không có lỗi.',
  },
  withdrawSuccess: {
    zh_cn: '提现成功',
    zhhant: '提現成功',
    en: 'Withdraw success',
    he: 'משיכה הצליחה',
    de: 'Auszahlung erfolgreich',
    es: 'Retiro exitoso',
    ru: 'Вывод выполнен',
    vi: 'Rút tiền thành công',
  },
  withdrawRevocation: {
    zh_cn: '提现撤销',
    zhhant: '提現撤銷',
    en: 'Withdraw revocation',
    he: 'ביטול משיכה',
    de: 'Auszahlung zurückrufen',
    es: 'Revocar retiro',
    ru: 'Отменить вывод',
    vi: 'Hủy rút tiền',
  },
  tradeFee: {
    zh_cn: '交易手续费',
    zhhant: '交易手續費',
    en: 'Trade fee',
    he: 'עמלת ענף',
    de: 'Handelsgebühr',
    es: 'Tarifa de operación',
    ru: 'Комиссия на операцию',
    vi: 'Phí dịch vụ giao dịch',
  },
  withdrawFee: {
    zh_cn: '提现手续费',
    zhhant: '提現手續費',
    en: 'Withdraw fee',
    he: 'עמלת משיכה',
    de: 'Auszahlungsgebühr',
    es: 'Tarifa de retiro',
    ru: 'Комиссия на вывод',
    vi: 'Phí dịch vụ rút tiền',
  },
  walletTransfer: {
    zh_cn: '钱包转账',
    zhhant: '錢包轉賬',
    en: 'Wallet transfer',
    he: 'העברה בין חשבונות',
    de: 'Geldbetrag überweisen',
    es: 'Transferencia de cartera',
    ru: 'Перевод внутри кошелька',
    vi: 'Chuyển khoản ví tiền',
  },
  profitsharing: {
    zh_cn: '分润信息',
    zhhant: '分潤信息',
    en: 'Profit sharing',
    he: 'שיתוף רווחים',
    de: 'Gewinnaufteilung',
    es: 'Compartir beneficios',
    ru: 'Разделение выигрышей',
    vi: 'Thông tin chia lợi nhuận',
  },
  profitSharingTradeStateNotRecorded: {
    zh_cn: '未入账',
    zhhant: '未入賬',
    en: 'Not recorded',
    he: 'לא רשום',
    de: 'Nicht erfasst',
    es: 'No registrado',
    ru: 'Не зафиксировано',
    vi: 'Chưa ghi sổ',
  },
  profitSharingTradeStateFail: {
    zh_cn: '入账失败',
    zhhant: '入賬失敗',
    en: 'Record failed',
    he: 'רשום כשל',
    de: 'Erfassung fehlgeschlagen',
    es: 'Registro fallido',
    ru: 'Фиксация зафиксировано',
    vi: 'Ghi sổ thất bại',
  },
  profitSharingTradeStateClose: {
    zh_cn: '交易关闭',
    zhhant: '交易關閉',
    en: 'Trade closed',
    he: 'טרייד סגר',
    de: 'Handel geschlossen',
    es: 'Operación cerrada',
    ru: 'Операция закрыта',
    vi: 'Giao dịch đóng cửa',
  },
  profitSharingTradeStateFundsRecorded: {
    zh_cn: '入账成功',
    zhhant: '入賬成功',
    en: 'Record success',
    he: 'רשום בהצלחה',
    de: 'Erfassung erfolgreich',
    es: 'Registro exitoso',
    ru: 'Фиксация зафиксировано',
    vi: 'Ghi sổ thành công',
  },
  transactionStateInit: {
    zh_cn: '初始化',
    zhhant: '初始化',
    en: 'Init',
    he: 'אתחול',
    de: 'Initialisieren',
    es: 'Iniciar',
    ru: 'Инициализация',
    vi: 'Khởi tạo',
  },
  transactionStatePending: {
    zh_cn: '待处理',
    zhhant: '待處理',
    en: 'Pending',
    he: 'בהמתנה',
    de: 'Ausstehend',
    es: 'Pendiente',
    ru: 'В ожидании',
    vi: 'Đang chờ xử lý',
  },
  transactionStateHangup: {
    zh_cn: '挂起',
    zhhant: '掛起',
    en: 'Hang up',
    he: 'להשעות',
    de: 'Aufgehängt',
    es: 'Suspender',
    ru: 'Приостановлено',
    vi: 'Đã tạm dừng',
  },
  transactionStateProcessing: {
    zh_cn: '处理中',
    zhhant: '處理中',
    en: 'Processing',
    he: 'בתהליך',
    de: 'In Bearbeitung',
    es: 'Procesando',
    ru: 'Обработка',
    vi: 'Đang xử lý',
  },
  transactionStateFail: {
    zh_cn: '交易失败',
    zhhant: '交易失敗',
    en: 'Trade failed',
    he: 'טרייד כשל',
    de: 'Handel fehlgeschlagen',
    es: 'Operación fallida',
    ru: 'Операция зафиксировано',
    vi: 'Giao dịch thất bại',
  },
  transactionStateClose: {
    zh_cn: '交易关闭',
    zhhant: '交易關閉',
    en: 'Trade closed',
    he: 'טרייד סגר',
    de: 'Handel geschlossen',
    es: 'Operación cerrada',
    ru: 'Операция закрыта',
    vi: 'Giao dịch đóng cửa',
  },
  transactionStateSuccess: {
    zh_cn: '交易成功',
    zhhant: '交易成功',
    en: 'Trade success',
    he: 'טרייד הצליח',
    de: 'Handel erfolgreich',
    es: 'Operación exitosa',
    ru: 'Операция зафиксировано',
    vi: 'Giao dịch thành công',
  },
  principal: {
    zh_cn: '本金',
    zhhant: '本金',
    en: 'Principal',
    he: 'Principal',
    de: 'Principal',
    es: 'Principal',
    ru: 'Principal',
    vi: 'Bản Vốn',
  },
  gift: {
    zh_cn: '赠送',
    zhhant: '贈送',
    en: 'Gift',
    he: 'Gift',
    de: 'Gift',
    es: 'Gift',
    ru: 'Gift',
    vi: 'Quà Tặng',
  },
  orderManualPending: {
    zh_cn: '待人工处理',
    zhhant: '待人工处理',
    en: 'Pending',
    he: 'Pending',
    de: 'Pending',
    es: 'Pending',
    ru: 'Pending',
    vi: 'Pending',
  },
  orderInit: {
    zh_cn: '初始下单',
    zhhant: '初始下單',
    en: 'Init',
    he: 'order init',
    de: 'order init',
    es: 'order init',
    ru: 'order init',
    vi: 'order init',
  },
  orderWait: {
    zh_cn: '订单等待处理',
    zhhant: '訂單等待處理',
    en: 'order wait',
    he: 'order wait',
    de: 'order wait',
    es: 'order wait',
    ru: 'order wait',
    vi: 'order wait',
  },
  orderProcess: {
    zh_cn: '充电中',
    zhhant: '充電中',
    en: 'order process',
    he: 'order process',
    de: 'order process',
    es: 'order process',
    ru: 'order process',
    vi: 'order process',
  },
  orderAbnormal: {
    zh_cn: '订单异常',
    zhhant: '訂單異常',
    en: 'order abnormal',
    he: 'order abnormal',
    de: 'order abnormal',
    es: 'order abnormal',
    ru: 'order abnormal',
    vi: 'order abnormal',
  },
  orderClose: {
    zh_cn: '订单关闭',
    zhhant: '訂單關閉',
    en: 'order close',
    he: 'order close',
    de: 'order close',
    es: 'order close',
    ru: 'order close',
    vi: 'order close',
  },
  orderFinish: {
    zh_cn: '充电完成',
    zhhant: '充電完成',
    en: 'order finish',
    he: 'order finish',
    de: 'order finish',
    es: 'order finish',
    ru: 'order finish',
    vi: 'order finish',
  },
  transactionId: {
    zh_cn: '交易ID',
    zhhant: '交易ID',
    en: 'Transaction ID',
    he: 'Transaction ID',
    de: 'Transaction ID',
    es: 'Transaction ID',
    ru: 'Transaction ID',
    vi: 'Transaction ID',
  },
  outOrderId: {
    zh_cn: '外部订单',
    zhhant: '外部訂單',
    en: 'Out Order',
    he: 'Out Order',
    de: 'Out Order',
    es: 'Out Order',
    ru: 'Out Order',
    vi: 'Out Order',
  },
  outRefundId: {
    zh_cn: '外部退款单号',
    zhhant: '外部退款单号',
    en: 'Out Refund ID',
    he: 'Out Refund ID',
    de: 'Out Refund ID',
    es: 'Out Refund ID',
    ru: 'Out Refund ID',
    vi: 'Out Refund ID',
  },
  pay: {
    zh_cn: '支付',
    zhhant: '支付',
    en: 'Pay',
    he: 'Pay',
    de: 'Pay',
    es: 'Pay',
    ru: 'Pay',
    vi: 'Pay',
  },
  refund: {
    zh_cn: '退款',
    zhhant: '退款',
    en: 'Refund',
    he: 'Refund',
    de: 'Refund',
    es: 'Refund',
    ru: 'Refund',
    vi: 'Refund',
  },
  recharge: {
    zh_cn: '充值',
    zhhant: '充值',
    en: 'Recharge',
    he: 'טעינה',
    de: 'Aufladen',
    es: 'Recarga',
    ru: 'Пополнение',
    vi: 'Nạp Tiền',
  },
  withhole: {
    zh_cn: '提现',
    zhhant: '提現',
    en: 'Withdraw',
    he: 'משיכה',
    de: 'Auszahlung',
    es: 'Retirar',
    ru: 'Вывести',
    vi: 'Rút Tiền',
  },
  prepayment: {
    zh_cn: '预付费',
    zhhant: '預付費',
    en: 'Prepayment',
    he: 'Prepayment',
    de: 'Prepayment',
    es: 'Prepayment',
    ru: 'Prepayment',
    vi: 'Prepayment',
  },
  postpayment: {
    zh_cn: '后付费',
    zhhant: '後付費',
    en: 'Postpayment',
    he: 'Postpayment',
    de: 'Postpayment',
    es: 'Postpayment',
    ru: 'Postpayment',
    vi: 'Postpayment',
  },
  sessionManualSettlement: {
    zh_cn: '手动结算',
    zhhant: '手動結算',
    en: 'Manual Settlement',
    he: 'Manual Settlement',
    de: 'Manual Settlement',
    es: 'Manual Settlement',
    ru: 'Manual Settlement',
    vi: 'Manual Settlement',
  },
  free: {
    zh_cn: '免费',
    zhhant: '免費',
    en: 'Free',
    he: 'Free',
    de: 'Free',
    es: 'Free',
    ru: 'Free',
    vi: 'Free',
  },
  tppay: {
    zh_cn: '第三方充电平台',
    zhhant: '第三方充电平台',
    en: 'Third-party platform payment',
    he: 'Third-party platform payment',
    de: 'Third-party platform payment',
    es: 'Third-party platform payment',
    ru: 'Third-party platform payment',
    vi: 'Third-party platform payment',
  },
  wechatPay: {
    zh_cn: '微信支付',
    zhhant: '微信支付',
    en: 'Wechat Pay',
    he: 'Wechat Pay',
    de: 'Wechat Pay',
    es: 'Wechat Pay',
    ru: 'Wechat Pay',
    vi: 'Wechat Pay',
  },
  aliPay: {
    zh_cn: '支付宝支付',
    zhhant: '支付寶支付',
    en: 'Ali Pay',
    he: 'Ali Pay',
    de: 'Ali Pay',
    es: 'Ali Pay',
    ru: 'Ali Pay',
    vi: 'Ali Pay',
  },
  group: {
    zh_cn: '集团支付',
    zhhant: '集團支付',
    en: 'Group Pay',
    he: 'Group Pay',
    de: 'Group Pay',
    es: 'Group Pay',
    ru: 'Group Pay',
    vi: 'Group Pay',
  },
  idcard: {
    zh_cn: '鉴权卡支付',
    zhhant: '鑑權卡支付',
    en: 'ID Card Pay',
    he: 'ID Card Pay',
    de: 'ID Card Pay',
    es: 'ID Card Pay',
    ru: 'ID Card Pay',
    vi: 'ID Card Pay',
  },
  walletCard: {
    zh_cn: '钱包卡支付',
    zhhant: '錢包卡支付',
    en: 'Wallet Card Pay',
    he: 'Wallet Card Pay',
    de: 'Wallet Card Pay',
    es: 'Wallet Card Pay',
    ru: 'Wallet Card Pay',
    vi: 'Wallet Card Pay',
  },
  userBalance: {
    zh_cn: '用户钱包支付',
    zhhant: '用戶錢包支付',
    en: 'User Wallet Pay',
    he: 'User Wallet Pay',
    de: 'User Wallet Pay',
    es: 'User Wallet Pay',
    ru: 'User Wallet Pay',
    vi: 'User Wallet Pay',
  },
  manul: {
    zh_cn: '后台支付',
    zhhant: '後台支付',
    en: 'Manul Pay',
    he: 'Manul Pay',
    de: 'Manul Pay',
    es: 'Manul Pay',
    ru: 'Manul Pay',
    vi: 'Manul Pay',
  },
  vin: {
    zh_cn: 'VIN 支付',
    zhhant: 'VIN 支付',
    en: 'VIN Pay',
    he: 'VIN Pay',
    de: 'VIN Pay',
    es: 'VIN Pay',
    ru: 'VIN Pay',
    vi: 'VIN Pay',
  },
  paypal: {
    zh_cn: 'PayPal 支付',
    zhhant: 'PayPal 支付',
    en: 'PayPal Pay',
    he: 'PayPal Pay',
    de: 'PayPal Pay',
    es: 'PayPal Pay',
    ru: 'PayPal Pay',
    vi: 'PayPal Pay',
  },
  stripe: {
    zh_cn: 'Stripe 支付',
    zhhant: 'Stripe 支付',
    en: 'Stripe Pay',
    he: 'Stripe Pay',
    de: 'Stripe Pay',
    es: 'Stripe Pay',
    ru: 'Stripe Pay',
    vi: 'Stripe Pay',
  },
  revocationWithdrawTip: {
    zh_cn: '仅提现入账失败的订单可提现，确定要撤销此订单吗？',
    zhhant: '僅提現入賬失敗的訂單可提現，確定要撤銷此訂單嗎？',
    en: 'Only orders that failed to enter the account can be withdrawn. Are you sure you want to revoke this order?',
    he: 'Only orders that failed to enter the account can be withdrawn. Are you sure you want to revoke this order?',
    de: 'Only orders that failed to enter the account can be withdrawn. Are you sure you want to revoke this order?',
    es: 'Only orders that failed to enter the account can be withdrawn. Are you sure you want to revoke this order?',
    ru: 'Only orders that failed to enter the account can be withdrawn. Are you sure you want to revoke this order?',
    vi: 'Only orders that failed to enter the account can be withdrawn. Are you sure you want to revoke this order?',
  },
  occupySettlementTip: {
    zh_cn: '占桩结算, 默认使用用户余额, 余额不够时，将会结算失败!!! 确定要占用结算吗？',
    zhhant: '占樁結算, 默認使用用戶餘額, 餘額不夠時，將會結算失敗!!! 確定要占用結算嗎？',
    en: 'Occupy settlement, default to use user balance. If the balance is not enough, it will fail!!! Are you sure you want to occupy and settle?',
    he: 'Occupy settlement, default to use user balance. If the balance is not enough, it will fail!!! Are you sure you want to occupy and settle?',
    de: 'Occupy settlement, default to use user balance. If the balance is not enough, it will fail!!! Are you sure you want to occupy and settle?',
    es: 'Occupy settlement, default to use user balance. If the balance is not enough, it will fail!!! Are you sure you want to occupy and settle?',
    ru: 'Occupy settlement, default to use user balance. If the balance is not enough, it will fail!!! Are you sure you want to occupy and settle?',
    vi: 'Occupy settlement, default to use user balance. If the balance is not enough, it will fail!!! Are you sure you want to occupy and settle?',
  },
  Payment: {
    zh_cn: '支付渠道',
    zhhant: '支付渠道',
    en: 'payment method',
    he: 'בחר אצלו',
    de: 'Zahlungsmethode auswählen',
    es: 'el método de pago',
    ru: 'способ оплаты',
    vi: 'Chọn cách thanh toán',
  },
}
